
export const roundFigureNum = (NumToRoundUp) => {
    let roundOffNum = Math.round(NumToRoundUp * 100) / 100
    return roundOffNum;
}

